const country = {
    en: [
        {"name":"Angola"},
        {"name":"Afghanistan"},
        {"name": "Albania"},
        {"name": "Algeria"},
        {"name": "Andorra"},
        {"name": "Anguilla"},
        {"name": "Barbuda Antigua"},
        {"name": "Argentina"},
        {"name": "Armenia"},
        {"name": "Australia"},
        {"name": "Austria"},
        {"name": "Azerbaijan"},
        {"name": "Bahamas"},
        {"name": "Bahrain"},
        {"name": "Bangladesh"},
        {"name": "Barbados"},
        {"name": "Belarus"},
        {"name": "Belgium"},
        {"name": "Belize"},
        {"name": "Benin"},
        {"name": "Bermuda Is."},
        {"name": "Bolivia"},
        {"name": "Botswana"},
        {"name": "Brazil"},
        {"name": "Brunei"},
        {"name": "Bulgaria"},
        {"name": "Burkina-faso"},
        {"name": "Burma"},
        {"name": "Burundi"},
        {"name": "Cameroon"},
        {"name": "Canada"},
        {"name": "Central African Republic"},
        {"name": "Chad"},
        {"name": "Chile"},
        {"name": "China"},
        {"name": "Colombia"},
        {"name": "Congo"},
        {"name": "Cook Is."},
        {"name": "Costa Rica"},
        {"name": "Cuba"},
        {"name": "Cyprus"},
        {"name": "Czech Republic"},
        {"name": "Denmark"},
        {"name": "Djibouti"},
        {"name": "Dominica Rep."},
        {"name": "Ecuador"},
        {"name": "Egypt"},
        {"name": "EI Salvador"},
        {"name": "Estonia"},
        {"name": "Ethiopia"},
        {"name": "Fiji"},
        {"name": "Finland"},
        {"name": "France"},
        {"name": "French Guiana"},
        {"name": "Gabon"},
        {"name": "Gambia"},
        {"name": "Georgia"},
        {"name": "Germany"},
        {"name": "Ghana"},
        {"name": "Gibraltar"},
        {"name": "Greece"},
        {"name": "Grenada"},
        {"name": "Guam"},
        {"name": "Guatemala"},
        {"name": "Guinea"},
        {"name": "Guyana"},
        {"name": "Haiti"},
        {"name": "Honduras"},
        {"name": "Hongkong"},
        {"name": "Hungary"},
        {"name": "Iceland"},
        {"name": "India"},
        {"name": "Indonesia"},
        {"name": "Iran"},
        {"name": "Iraq"},
        {"name": "Ireland"},
        {"name": "Israel"},
        {"name": "Italy"},
        {"name": "Jamaica"},
        {"name": "Japan"},
        {"name": "Jordan"},
        {"name": "Kampuchea (Cambodia )"},
        {"name": "Kazakstan"},
        {"name": "Kenya"},
        {"name": "Korea"},
        {"name": "Kuwait"},
        {"name": "Kyrgyzstan"},
        {"name": "Laos"},
        {"name": "Latvia"},
        {"name": "Lebanon"},
        {"name": "Lesotho"},
        {"name": "Liberia"},
        {"name": "Libya"},
        {"name": "Liechtenstein"},
        {"name": "Lithuania"},
        {"name": "Luxembourg"},
        {"name": "Macao"},
        {"name": "Madagascar"},
        {"name": "Malawi"},
        {"name": "Malaysia"},
        {"name": "Maldives"},
        {"name": "Mali"},
        {"name": "Malta"},
        {"name": "Mauritius"},
        {"name": "Mexico"},
        {"name": "Moldova"},
        {"name": "Monaco"},
        {"name": "Mongolia"},
        {"name": "Montserrat Is."},
        {"name": "Morocco"},
        {"name": "Mozambique"},
        {"name": "Namibia"},
        {"name": "Nauru"},
        {"name": "Nepal"},
        {"name": "Netherlands"},
        {"name": "New Zealand"},
        {"name": "Nicaragua"},
        {"name": "Niger"},
        {"name": "Nigeria"},
        {"name": "North Korea"},
        {"name": "Norway"},
        {"name": "Oman"},
        {"name": "Pakistan"},
        {"name": "Panama"},
        {"name": "Papua New Cuinea"},
        {"name": "Paraguay"},
        {"name": "Peru"},
        {"name": "Philippines"},
        {"name": "Poland"},
        {"name": "French Polynesia"},
        {"name": "Portugal"},
        {"name": "Puerto Rico"},
        {"name": "Qatar"},
        {"name": "Romania"},
        {"name": "Russia"},
        {"name": "Saint Lueia"},
        {"name": "Saint Vincent"},
        {"name": "San Marino"},
        {"name": "Sao Tome and Principe"},
        {"name": "Saudi Arabia"},
        {"name": "Senegal"},
        {"name": "Seychelles"},
        {"name": "Sierra Leone"},
        {"name": "Singapore"},
        {"name": "Slovakia"},
        {"name": "Slovenia"},
        {"name": "Solomon Is."},
        {"name": "Somali"},
        {"name": "South Africa"},
        {"name": "Spain"},
        {"name": "Sri Lanka"},
        {"name": "Sudan"},
        {"name": "Suriname"},
        {"name": "Swaziland"},
        {"name": "Sweden"},
        {"name": "Switzerland"},
        {"name": "Syria"},
        {"name": "Taiwan"},
        {"name": "Tajikstan"},
        {"name": "Tanzania"},
        {"name": "Thailand"},
        {"name": "Togo"},
        {"name": "Tonga"},
        {"name": "Trinidad and Tobago"},
        {"name": "Tunisia"},
        {"name": "Turkey"},
        {"name": "Turkmenistan"},
        {"name": "Uganda"},
        {"name": "Ukraine"},
        {"name": "United Arab Emirates"},
        {"name": "United Kiongdom"},
        {"name": "United States of America"},
        {"name": "Uruguay"},
        {"name": "Uzbekistan"},
        {"name": "Venezuela"},
        {"name": "Vietnam"},
        {"name": "Yemen"},
        {"name": "Yugoslavia"},
        {"name": "Zimbabwe"},
        {"name": "Zaire"},
        {"name": "Zambia"}
    ],
    // zh: [
    //     {"AO", "安哥拉"},
    //     {"AF", "阿富汗"},
    //     {"AL", "阿尔巴尼亚"},
    //     {"DZ", "阿尔及利亚"},
    //     {"AD", "安道尔共和国"},
    //     {"AI", "安圭拉岛"},
    //     {"AG", "安提瓜和巴布达"},
    //     {"AR", "阿根廷"},
    //     {"AM", "亚美尼亚"},
    //     {"AU", "澳大利亚"},
    //     {"AT", "奥地利"},
    //     {"AZ", "阿塞拜疆"},
    //     {"BS", "巴哈马"},
    //     {"BH", "巴林"},
    //     {"BD", "孟加拉国"},
    //     {"BB", "巴巴多斯"},
    //     {"BY", "白俄罗斯"},
    //     {"BE", "比利时"},
    //     {"BZ", "伯利兹"},
    //     {"BJ", "贝宁"},
    //     {"BM", "百慕大群岛"},
    //     {"BO", "玻利维亚"},
    //     {"BW", "博茨瓦纳"},
    //     {"BR", "巴西"},
    //     {"BN", "文莱"},
    //     {"BG", "保加利亚"},
    //     {"BF", "布基纳法索"},
    //     {"MM", "缅甸"},
    //     {"BI", "布隆迪"},
    //     {"CM", "喀麦隆"},
    //     {"CA", "加拿大"},
    //     {"CF", "中非共和国"},
    //     {"TD", "乍得"},
    //     {"CL", "智利"},
    //     {"CN", "中国"},
    //     {"CO", "哥伦比亚"},
    //     {"CG", "刚果"},
    //     {"CK", "库克群岛"},
    //     {"CR", "哥斯达黎加"},
    //     {"CU", "古巴"},
    //     {"CY", "塞浦路斯"},
    //     {"CZ", "捷克"},
    //     {"DK", "丹麦"},
    //     {"DJ", "吉布提"},
    //     {"DO", "多米尼加共和国"},
    //     {"EC", "厄瓜多尔"},
    //     {"EG", "埃及"},
    //     {"SV", "萨尔瓦多"},
    //     {"EE", "爱沙尼亚"},
    //     {"ET", "埃塞俄比亚"},
    //     {"FJ", "斐济"},
    //     {"FI", "芬兰"},
    //     {"FR", "法国"},
    //     {"GF", "法属圭亚那"},
    //     {"GA", "加蓬"},
    //     {"GM", "冈比亚"},
    //     {"GE", "格鲁吉亚"},
    //     {"DE", "德国"},
    //     {"GH", "加纳"},
    //     {"GI", "直布罗陀"},
    //     {"GR", "希腊"},
    //     {"GD", "格林纳达"},
    //     {"GU", "关岛"},
    //     {"GT", "危地马拉"},
    //     {"GN", "几内亚"},
    //     {"GY", "圭亚那"},
    //     {"HT", "海地"},
    //     {"HN", "洪都拉斯"},
    //     {"HK", "香港"},
    //     {"HU", "匈牙利"},
    //     {"IS", "冰岛"},
    //     {"IN", "印度"},
    //     {"ID", "印度尼西亚"},
    //     {"IR", "伊朗"},
    //     {"IQ", "伊拉克"},
    //     {"IE", "爱尔兰"},
    //     {"IL", "以色列"},
    //     {"IT", "意大利"},
    //     {"JM", "牙买加"},
    //     {"JP", "日本"},
    //     {"JO", "约旦"},
    //     {"KH", "柬埔寨"},
    //     {"KZ", "哈萨克斯坦"},
    //     {"KE", "肯尼亚"},
    //     {"KR", "韩国"},
    //     {"KW", "科威特"},
    //     {"KG", "吉尔吉斯坦"},
    //     {"LA", "老挝"},
    //     {"LV", "拉脱维亚"},
    //     {"LB", "黎巴嫩"},
    //     {"LS", "莱索托"},
    //     {"LR", "利比里亚"},
    //     {"LY", "利比亚"},
    //     {"LI", "列支敦士登"},
    //     {"LT", "立陶宛"},
    //     {"LU", "卢森堡"},
    //     {"MO", "澳门"},
    //     {"MG", "马达加斯加"},
    //     {"MW", "马拉维"},
    //     {"MY", "马来西亚"},
    //     {"MV", "马尔代夫"},
    //     {"ML", "马里"},
    //     {"MT", "马耳他"},
    //     {"MU", "毛里求斯"},
    //     {"MX", "墨西哥"},
    //     {"MD", "摩尔多瓦"},
    //     {"MC", "摩纳哥"},
    //     {"MN", "蒙古"},
    //     {"MS", "蒙特塞拉特岛"},
    //     {"MA", "摩洛哥"},
    //     {"MZ", "莫桑比克"},
    //     {"NA", "纳米比亚"},
    //     {"NR", "瑙鲁"},
    //     {"NP", "尼泊尔"},
    //     {"NL", "荷兰"},
    //     {"NZ", "新西兰"},
    //     {"NI", "尼加拉瓜"},
    //     {"NE", "尼日尔"},
    //     {"NG", "尼日利亚"},
    //     {"KP", "朝鲜"},
    //     {"NO", "挪威"},
    //     {"OM", "阿曼"},
    //     {"PK", "巴基斯坦"},
    //     {"PA", "巴拿马"},
    //     {"PG", "巴布亚新几内亚"},
    //     {"PY", "巴拉圭"},
    //     {"PE", "秘鲁"},
    //     {"PH", "菲律宾"},
    //     {"PL", "波兰"},
    //     {"PF", "法属玻利尼西亚"},
    //     {"PT", "葡萄牙"},
    //     {"PR", "波多黎各"},
    //     {"QA", "卡塔尔"},
    //     {"RO", "罗马尼亚"},
    //     {"RU", "俄罗斯"},
    //     {"LC", "圣卢西亚"},
    //     {"VC", "圣文森特岛"},
    //     {"SM", "圣马力诺"},
    //     {"ST", "圣多美和普林西比"},
    //     {"SA", "沙特阿拉伯"},
    //     {"SN", "塞内加尔"},
    //     {"SC", "塞舌尔"},
    //     {"SL", "塞拉利昂"},
    //     {"SG", "新加坡"},
    //     {"SK", "斯洛伐克"},
    //     {"SI", "斯洛文尼亚"},
    //     {"SB", "所罗门群岛"},
    //     {"SO", "索马里"},
    //     {"ZA", "南非"},
    //     {"ES", "西班牙"},
    //     {"LK", "斯里兰卡"},
    //     {"SD", "苏丹"},
    //     {"SR", "苏里南"},
    //     {"SZ", "斯威士兰"},
    //     {"SE", "瑞典"},
    //     {"CH", "瑞士"},
    //     {"SY", "叙利亚"},
    //     {"TW", "台湾省"},
    //     {"TJ", "塔吉克斯坦"},
    //     {"TZ", "坦桑尼亚"},
    //     {"TH", "泰国"},
    //     {"TG", "多哥"},
    //     {"TO", "汤加"},
    //     {"TT", "特立尼达和多巴哥"},
    //     {"TN", "突尼斯"},
    //     {"TR", "土耳其"},
    //     {"TM", "土库曼斯坦"},
    //     {"UG", "乌干达"},
    //     {"UA", "乌克兰"},
    //     {"AE", "阿拉伯联合酋长国"},
    //     {"GB", "英国"},
    //     {"US", "美国"},
    //     {"UY", "乌拉圭"},
    //     {"UZ", "乌兹别克斯坦"},
    //     {"VE", "委内瑞拉"},
    //     {"VN", "越南"},
    //     {"YE", "也门"},
    //     {"YU", "南斯拉夫"},
    //     {"ZW", "津巴布韦"},
    //     {"ZR", "扎伊尔"},
    //     {"ZM", "赞比亚"}
    // ]
};
export default country;


// WEBPACK FOOTER //
// ./src/assets/js/country.js